<template>
  <div class="ui-breadcrumbs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods:{},
  created () {},
  mounted() {
    let firstCapitalize = this.$el.querySelectorAll('.capitalize');
    if(firstCapitalize.length>0) {
      firstCapitalize.forEach(function (firstCapitalizeItem) {
        let firstCapitalizeInner = firstCapitalizeItem.innerHTML;
        firstCapitalizeItem.innerHTML = firstCapitalizeInner.charAt(0).toUpperCase() + firstCapitalizeInner.slice(1)
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.ui-breadcrumbs {
  & > * {
    &:not(:last-child) {
      &:after {
        content: '/';
        margin-left: 0.5vw;
        margin-right: 0.5vw;
      }
    }
    &:last-child {
      opacity: 0.5;
    }
  }
}
</style>
